<template>
    <div class="TopicsTopEntrance" v-loading="loading">
        <div class="TopicsTopEntrance-header">
            <div>公共弹幕管理</div>
            <el-button type="primary" @click="handleAdd">
                新增
            </el-button>
        </div>
        <el-form label-width="80px" :inline="true">
            <el-form-item label="类目">
                <el-select v-model="queryForm.categoryId" placeholder="请选择状态">
                    <el-option label="全部" :value="0"></el-option>
                    <el-option v-for="(item, index) in categoryOption" :key="index" :label="item.label"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-button type="primary" @click="handleQuery">
                查询
            </el-button>
            <el-button @click="handleReset">
                重置
            </el-button>
        </el-form>
        <el-table :data="tableData" border>
            <el-table-column type="index" label="序号" align="center" width="120" />
            <el-table-column prop="content" label="弹幕内容" align="center" />
            <el-table-column prop="sort" label="弹幕排序" align="center" />
            <el-table-column prop="categoryName" label="类目" align="center" />
            <el-table-column prop="initialization" label="初始使用次数" align="center" />
            <el-table-column prop="used" label="真实使用次数" align="center" />
            <el-table-column label="更新时间" align="center" inline-template>
                <div>{{ new Date(row.updateTime).format('yyyy-MM-dd hh:mm:ss') }}</div>
            </el-table-column>
            <el-table-column inline-template label="操作" width="200px" align="center">
                <template>
                    <el-button type="primary" size="small" @click="handleEdit(row)">
                        编辑
                    </el-button>
                    <el-button size="small" @click="handleDelete(row)">
                        删除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination layout="prev, pager, next, jumper" :page-size="queryForm.pageSize"
                :current-page="queryForm.pageNum" :total="tableTotal" @current-change="handleCurrentChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            queryForm: {
                categoryId: 0,
                pageNum: 1,
                pageSize: 10
            },
            categoryOption: [],
            tableData: [],
            tableTotal: 0,
            loading: false
        }
    },
    mounted() {
        this.apiGetCategoryOptions()
        this.queryForm.pageNum = this.$route.query.pageNum ? Number(this.$route.query.pageNum) : 1
        this.queryForm.pageSize = this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10
        this.handleQuery()
    },
    methods: {
        apiGetCategoryOptions() {
            this.$http({
                url: this.$util.domain + '/adminapi/barrage/category/select/list',
                method: 'GET',
            }).then(res => {
                if (res.body.error === 10000) {
                    if (res.body.data && res.body.data.length) {
                        this.categoryOption = res.body.data.map(item => ({
                            label: item.name,
                            value: item.id
                        }))
                    } else {
                        this.categoryOption = []
                    }
                } else {
                    this.categoryOption = []
                    this.$util.errorMsg(res.body.message);
                }
            })
        },
        // 请求分页数据分页
        handleCurrentChange(val) {
            this.queryForm.pageNum = val;
            this.handleQuery()
        },
        handleDelete(row) {
            this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http({
                    method: 'GET',
                    url: this.$util.domain + '/adminapi/barrage/public/barrage/delete',
                    params: {
                        barrageId: row.id
                    }
                }).then(res => {
                    if (res.body.error === 10000) {
                        this.handleQuery()
                    } else {
                        this.$util.errorMsg(res.body.message);
                    }
                })
            })
        },
        handleAdd() {
            this.$router.push({
                path: '/yunying/PublicBulletinManagement/Detail'
            })
        },
        handleEdit(row) {
            this.$router.push({
                path: '/yunying/PublicBulletinManagement/Detail',
                query: {
                    barrageId: row.id
                }
            })
        },
        handleQuery() {
            this.loading = true
            this.$http({
                method: 'GET',
                url: this.$util.domain + '/adminapi/barrage/public/barrage/list',
                params: {
                    ...this.queryForm
                }
            }).then(res => {
                if (res.body.error === 10000) {
                    const { list, totalCount } = res.body.data
                    this.tableTotal = totalCount
                    if (list && list.length) {
                        this.tableData = list
                    } else {
                        this.tableData = []
                    }
                } else {
                    this.tableData = []
                    this.tableTotal = 0
                    this.$util.errorMsg(res.body.message);
                }
                this.loading = false
            }).catch(() => {
                this.tableData = []
                this.tableTotal = 0
                this.loading = false
            })
        },
        handleReset() {
            this.queryForm = {
                categoryId: 0,
                pageNum: 1,
                pageSize: 10
            }
            this.handleQuery()
        }
    },

    beforeRouteEnter(to, from, next) {
      if (from.path.includes('/yunying/PublicBulletinManagement/Detail')) {
         to.meta.refresh = true;
      }
      next();
   },
   activated() {
      if (this.$route.meta.refresh) {
         this.$route.meta.refresh = false;
         this.handleQuery();
      }
   }
}
</script>


<style scoped>
.TopicsTopEntrance-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #eee;
    font-size: 16px;
    padding: 0 10px 0 30px;
    margin: 20px 0;
}

.TopicsTopEntrance-main {
    padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// index.vue?3e128992